import SearchAutocomplete from './SearchAutocomplete'
import { BaseResult } from './types'

export * as searchPlugins from './Plugins'
export type { BaseResult }
export default SearchAutocomplete
